export default __webpack_public_path__ + "static/media/2c469c909649561f265494f6cc894de3aff80cd5dfe698160da72c2eddae478e.38fdd0c3.png";